(function () {
  'use strict';
  var lb, imgEl, stageEl;
  var st = { i: 0, items: [], zoom: false, timer: null, open: false, opener: null };
  var Z = { s: 1, x: 0, y: 0 };
  var MAX_ZOOM = 5, TAP_ZOOM = 2.5;
  var pts = {}, g = null, pinched = false, lastTap = { t: 0, x: 0, y: 0 };

  function svg(p) {
    return '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>';
  }
  var I = {
    zoomIn: svg('<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3M11 8v6M8 11h6"/>'),
    zoomOut: svg('<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3M8 11h6"/>'),
    play: svg('<path d="M7 4.5v15l12-7.5z"/>'),
    pause: svg('<path d="M8 5v14M16 5v14"/>'),
    full: svg('<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>'),
    exitFull: svg('<path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5"/>'),
    grid: svg('<path d="M5 5h.01M12 5h.01M19 5h.01M5 12h.01M12 12h.01M19 12h.01M5 19h.01M12 19h.01M19 19h.01" stroke-width="3"/>'),
    close: svg('<path d="M5 5l14 14M19 5L5 19"/>'),
    prev: svg('<path d="M15 4l-8 8 8 8"/>'),
    next: svg('<path d="M9 4l8 8-8 8"/>')
  };

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function sized(url, w) {
    if (!url) return '';
    return /[?&]width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function biggest(img) {
    var srcset = img.getAttribute('srcset') || '', re = /(\S+)\s+(\d+)w/g, m, best = null;
    while ((m = re.exec(srcset))) {
      var w = parseInt(m[2], 10);
      if (w <= 2048 && (!best || w > best.w)) best = { url: m[1], w: w };
    }
    return best ? best.url.replace(/^,+/, '') : img.getAttribute('src');
  }
  function collect() {
    var seen = {}, out = [];
    document.querySelectorAll('product-modal .product-media-modal__content img[data-media-id]').forEach(function (img) {
      var id = img.getAttribute('data-media-id');
      if (seen[id]) return;
      seen[id] = 1;
      out.push({ id: id, src: biggest(img), thumb: sized(img.getAttribute('src'), 200), alt: img.alt || '' });
    });
    return out;
  }

  /* ---------- zoom engine (pinch, double tap, drag, wheel) ---------- */
  function stageCenter() {
    var r = stageEl.getBoundingClientRect();
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }
  function clampZ() {
    var sw = stageEl.clientWidth, sh = stageEl.clientHeight;
    var iw = imgEl.offsetWidth * Z.s, ih = imgEl.offsetHeight * Z.s;
    var mx = Math.max(0, (iw - sw) / 2), my = Math.max(0, (ih - sh) / 2);
    Z.x = clamp(Z.x, -mx, mx);
    Z.y = clamp(Z.y, -my, my);
  }
  function paint(instant) {
    imgEl.style.transition = instant ? 'none' : '';
    imgEl.style.transform = (Z.s === 1 && Z.x === 0 && Z.y === 0)
      ? ''
      : 'translate3d(' + Z.x + 'px,' + Z.y + 'px,0) scale(' + Z.s + ')';
    var zoomed = Z.s > 1.01;
    if (zoomed !== st.zoom) {
      st.zoom = zoomed;
      lb.classList.toggle('tsb-lb--zoomed', zoomed);
      lb.querySelector('[data-act="zoom"]').innerHTML = zoomed ? I.zoomOut : I.zoomIn;
    }
  }
  function resetZoom(instant) {
    Z.s = 1; Z.x = 0; Z.y = 0;
    paint(!!instant);
  }
  function toggleZoomAt(cx, cy) {
    if (Z.s > 1.01) {
      resetZoom(false);
    } else {
      var c = stageCenter();
      Z.s = TAP_ZOOM;
      Z.x = (cx - c.x) * (1 - TAP_ZOOM);
      Z.y = (cy - c.y) * (1 - TAP_ZOOM);
      clampZ();
      paint(false);
    }
  }
  function toggleZoom() {
    var c = stageCenter();
    toggleZoomAt(c.x, c.y);
  }
  function settle() {
    if (Z.s < 1.05) { resetZoom(false); return; }
    Z.s = Math.min(Z.s, MAX_ZOOM);
    clampZ();
    paint(false);
  }
  function insideImg(x, y) {
    var r = imgEl.getBoundingClientRect();
    return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  }
  function pcount() { return Object.keys(pts).length; }
  function two() { var k = Object.keys(pts); return [pts[k[0]], pts[k[1]]]; }
  function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
  function mid(a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; }

  function begin() {
    var n = pcount(), c = stageCenter();
    if (n === 1) {
      var p = pts[Object.keys(pts)[0]];
      g = { mode: 'pan', sx: p.x, sy: p.y, x0: Z.x, y0: Z.y, moved: false, dx: 0, dy: 0 };
    } else if (n >= 2) {
      var a = two(), m = mid(a[0], a[1]);
      g = {
        mode: 'pinch', d0: dist(a[0], a[1]) || 1, s0: Z.s,
        ux: (m.x - c.x - Z.x) / Z.s, uy: (m.y - c.y - Z.y) / Z.s
      };
      pinched = true;
    }
    imgEl.style.transition = 'none';
  }

  function onDown(e) {
    if (e.button !== undefined && e.button !== 0) return;
    if (e.target.closest('[data-act]')) return;
    pts[e.pointerId] = { x: e.clientX, y: e.clientY, type: e.pointerType };
    try { stageEl.setPointerCapture(e.pointerId); } catch (x) {}
    begin();
  }
  function onMove(e) {
    var p = pts[e.pointerId];
    if (!p) return;
    p.x = e.clientX; p.y = e.clientY;
    if (!g) return;
    if (g.mode === 'pinch' && pcount() >= 2) {
      var a = two(), m = mid(a[0], a[1]), c = stageCenter();
      var s = clamp(g.s0 * dist(a[0], a[1]) / g.d0, 0.8, MAX_ZOOM + 1);
      Z.s = s;
      Z.x = m.x - c.x - g.ux * s;
      Z.y = m.y - c.y - g.uy * s;
      paint(true);
    } else if (g.mode === 'pan' && pcount() === 1) {
      g.dx = e.clientX - g.sx;
      g.dy = e.clientY - g.sy;
      if (!g.moved && Math.hypot(g.dx, g.dy) > 6) {
        g.moved = true;
        lb.classList.add('tsb-lb--dragging');
      }
      if (!g.moved) return;
      if (Z.s > 1.01) {
        Z.x = g.x0 + g.dx;
        Z.y = g.y0 + g.dy;
        clampZ();
        paint(true);
      } else {
        imgEl.style.transform = 'translate3d(' + g.dx + 'px,0,0)';
      }
    }
  }
  function onEnd(e) {
    var p = pts[e.pointerId];
    if (!p) return;
    var type = p.type;
    delete pts[e.pointerId];
    if (pcount() > 0) { begin(); return; }
    var gg = g;
    g = null;
    lb.classList.remove('tsb-lb--dragging');
    imgEl.style.transition = '';
    if (!gg) return;
    if (pinched || gg.mode === 'pinch') { pinched = false; settle(); return; }
    if (gg.moved) {
      if (Z.s > 1.01) {
        clampZ();
        paint(false);
      } else if (e.type === 'pointerup' && Math.abs(gg.dx) > 50 && Math.abs(gg.dx) > Math.abs(gg.dy)) {
        imgEl.style.transform = '';
        stopPlay();
        go(gg.dx < 0 ? 1 : -1);
      } else {
        imgEl.style.transform = '';
      }
      return;
    }
    /* a tap */
    if (e.type !== 'pointerup') return;
    if (type === 'mouse') {
      if (insideImg(e.clientX, e.clientY)) toggleZoomAt(e.clientX, e.clientY);
      return;
    }
    var now = Date.now();
    if (now - lastTap.t < 320 && Math.hypot(e.clientX - lastTap.x, e.clientY - lastTap.y) < 35) {
      lastTap.t = 0;
      toggleZoomAt(e.clientX, e.clientY);
    } else {
      lastTap = { t: now, x: e.clientX, y: e.clientY };
    }
  }

  var wheelLock = 0, wheelAcc = 0, wheelTimer = null;
  function onWheel(e) {
    if (e.ctrlKey) {
      /* trackpad pinch on laptops */
      e.preventDefault();
      var c = stageCenter(), s0 = Z.s;
      var s = clamp(s0 * Math.exp(-e.deltaY * 0.01), 1, MAX_ZOOM);
      var ux = (e.clientX - c.x - Z.x) / s0, uy = (e.clientY - c.y - Z.y) / s0;
      Z.s = s;
      Z.x = e.clientX - c.x - ux * s;
      Z.y = e.clientY - c.y - uy * s;
      if (s < 1.02) { Z.s = 1; Z.x = 0; Z.y = 0; }
      clampZ();
      paint(true);
      return;
    }
    if (st.zoom) {
      e.preventDefault();
      Z.x -= e.deltaX;
      Z.y -= e.deltaY;
      clampZ();
      paint(true);
      return;
    }
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    e.preventDefault();
    var now = Date.now();
    if (now < wheelLock) return;
    wheelAcc += e.deltaX;
    clearTimeout(wheelTimer);
    wheelTimer = setTimeout(function () { wheelAcc = 0; }, 200);
    if (Math.abs(wheelAcc) > 60) {
      stopPlay();
      go(wheelAcc > 0 ? 1 : -1);
      wheelAcc = 0;
      wheelLock = now + 500;
    }
  }

  /* ---------- build ---------- */
  function build() {
    lb = document.createElement('div');
    lb.className = 'tsb-lb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product images');
    var canFull = !!(document.documentElement.requestFullscreen || document.documentElement.webkitRequestFullscreen);
    lb.innerHTML =
      '<div class="tsb-lb__bar"><div class="tsb-lb__count"></div><div class="tsb-lb__tools">' +
      '<button type="button" class="tsb-lb__btn" data-act="zoom" aria-label="Toggle zoom">' + I.zoomIn + '</button>' +
      '<button type="button" class="tsb-lb__btn" data-act="play" aria-label="Toggle slideshow">' + I.play + '</button>' +
      (canFull ? '<button type="button" class="tsb-lb__btn" data-act="full" aria-label="Toggle full screen">' + I.full + '</button>' : '') +
      '<button type="button" class="tsb-lb__btn" data-act="thumbs" aria-label="Toggle thumbnails">' + I.grid + '</button>' +
      '<button type="button" class="tsb-lb__btn" data-act="close" aria-label="Close">' + I.close + '</button>' +
      '</div></div>' +
      '<div class="tsb-lb__stage">' +
      '<button type="button" class="tsb-lb__nav tsb-lb__nav--prev" data-act="prev" aria-label="Previous">' + I.prev + '</button>' +
      '<img class="tsb-lb__img" alt="" draggable="false">' +
      '<button type="button" class="tsb-lb__nav tsb-lb__nav--next" data-act="next" aria-label="Next">' + I.next + '</button>' +
      '</div><div class="tsb-lb__thumbs"></div>';
    document.body.appendChild(lb);
    stageEl = lb.querySelector('.tsb-lb__stage');
    imgEl = lb.querySelector('.tsb-lb__img');

    lb.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]');
      if (b) {
        var a = b.getAttribute('data-act');
        if (a === 'close') requestClose();
        else if (a === 'prev') { stopPlay(); go(-1); }
        else if (a === 'next') { stopPlay(); go(1); }
        else if (a === 'zoom') toggleZoom();
        else if (a === 'play') togglePlay();
        else if (a === 'full') toggleFull();
        else if (a === 'thumbs') lb.classList.toggle('tsb-lb--nothumbs');
        return;
      }
      var t = e.target.closest('.tsb-lb__thumb');
      if (t) { stopPlay(); show(parseInt(t.getAttribute('data-i'), 10)); }
    });

    stageEl.addEventListener('pointerdown', onDown);
    stageEl.addEventListener('pointermove', onMove);
    stageEl.addEventListener('pointerup', onEnd);
    stageEl.addEventListener('pointercancel', onEnd);
    lb.addEventListener('wheel', onWheel, { passive: false });
    /* stop iOS Safari zooming the whole page while pinching the viewer */
    ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (n) {
      lb.addEventListener(n, function (e) { e.preventDefault(); });
    });

    document.addEventListener('keydown', function (e) {
      if (!st.open) return;
      if (e.key === 'Escape') requestClose();
      else if (e.key === 'ArrowLeft') { stopPlay(); go(-1); }
      else if (e.key === 'ArrowRight') { stopPlay(); go(1); }
    });
    document.addEventListener('fullscreenchange', function () {
      var b = lb.querySelector('[data-act="full"]');
      if (b) b.innerHTML = document.fullscreenElement ? I.exitFull : I.full;
    });
  }

  function renderThumbs() {
    var wrap = lb.querySelector('.tsb-lb__thumbs');
    wrap.innerHTML = '';
    st.items.forEach(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tsb-lb__thumb';
      b.setAttribute('data-i', i);
      b.setAttribute('aria-label', 'Image ' + (i + 1));
      b.innerHTML = '<img alt="" src="' + it.thumb + '">';
      wrap.appendChild(b);
    });
  }
  function show(i) {
    var n = st.items.length;
    st.i = (i + n) % n;
    resetZoom(true);
    imgEl.src = st.items[st.i].src;
    imgEl.alt = st.items[st.i].alt;
    lb.querySelector('.tsb-lb__count').textContent = (st.i + 1) + ' / ' + n;
    lb.querySelectorAll('.tsb-lb__thumb').forEach(function (t, k) {
      t.classList.toggle('is-active', k === st.i);
      if (k === st.i && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'center' });
    });
    [st.i + 1, st.i - 1].forEach(function (k) { var p = new Image(); p.src = st.items[(k + n) % n].src; });
  }
  function go(d) { show(st.i + d); }
  function togglePlay() { st.timer ? stopPlay() : startPlay(); }
  function startPlay() {
    st.timer = setInterval(function () { go(1); }, 3000);
    lb.querySelector('[data-act="play"]').innerHTML = I.pause;
  }
  function stopPlay() {
    if (st.timer) { clearInterval(st.timer); st.timer = null; }
    if (lb) lb.querySelector('[data-act="play"]').innerHTML = I.play;
  }
  function toggleFull() {
    if (document.fullscreenElement) { document.exitFullscreen(); return; }
    var f = lb.requestFullscreen || lb.webkitRequestFullscreen;
    if (f) f.call(lb);
  }

  function openAt(id, opener) {
    var items = collect();
    if (!items.length) return false;
    if (!lb) build();
    st.items = items;
    st.opener = opener;
    var idx = 0;
    items.forEach(function (it, k) { if (it.id === id) idx = k; });
    renderThumbs();
    lb.classList.remove('tsb-lb--nothumbs');
    lb.hidden = false;
    st.open = true;
    pts = {}; g = null; pinched = false;
    document.documentElement.style.overflow = 'hidden';
    show(idx);
    history.pushState({ tsbLb: 1 }, '', location.href);
    lb.querySelector('[data-act="close"]').focus();
    return true;
  }
  function closeUI() {
    if (!st.open) return;
    st.open = false;
    stopPlay();
    if (document.fullscreenElement && document.exitFullscreen) document.exitFullscreen().catch(function () {});
    lb.hidden = true;
    document.documentElement.style.overflow = '';
    if (st.opener && st.opener.focus) st.opener.focus();
  }
  function requestClose() {
    if (history.state && history.state.tsbLb) history.back();
    else closeUI();
  }
  window.addEventListener('popstate', function () { if (st.open) closeUI(); });

  /* open our lightbox instead of the default zoom modal */
  document.addEventListener('click', function (e) {
    var op = e.target.closest && e.target.closest('modal-opener.product__modal-opener--image');
    if (!op || !op.closest('.product__media-wrapper')) return;
    var holder = op.querySelector('[data-media-id]');
    if (openAt(holder ? holder.getAttribute('data-media-id') : '', op.querySelector('button'))) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  /* size chart dialog */
  document.addEventListener('click', function (e) {
    var d = document.querySelector('.tsb-sizechart');
    if (!d) return;
    if (e.target.closest('[data-tsb-sizechart]')) d.showModal();
    else if (e.target.closest('[data-tsb-sizechart-close]') || e.target === d) d.close();
  });
})();